/** Exchange-rate options in header — aligned with ssr-web-index / spikex-ai-web */
const assistConfig = [
  {
    key: "usd",
    name: "USD",
    note: "$",
    decimal: 2,
  },
  {
    key: "aed",
    name: "AED",
    note: "د.إ",
    decimal: 2,
  },
  {
    key: "sar",
    name: "SAR",
    note: "ر.س",
    decimal: 2,
  },
  {
    key: "brl",
    name: "BRL",
    note: "R$",
    decimal: 2,
  },
  {
    key: "vnd",
    name: "VND",
    note: "₫",
    decimal: 0,
  },
];

export default assistConfig;
